import React, { useContext, useEffect } from 'react';
import { CssBaseline } from '@material-ui/core';
import { DialogProvider } from '@michelin/acid-components';
import {
  APPS,
  CentralProvider,
  CentralProviderContext,
  Languages,
  MaestroQueryClientProvider,
  THEMES,
  initReactI18next,
  useTranslation,
} from '@michelin/central-provider';
import i18n from '@michelin/central-provider/dist/translations/CentralTranslation';
import { prefixedTranslations, sharedTranslations } from '@michelin/maestro-common-translations';
import { PrintContext, usePrintContext } from 'components/PrintContext';
import { PrintOrderPartList } from 'compositions/OrderDetail/components/PrintOrderPartList';
import moment from 'moment';
import 'moment/locale/en-ca';
import 'moment/locale/fr-ca';
import { Router } from 'react-router-dom';
import { apigatewayBaseRoute } from 'services/restApiConst';
import history from 'utils/history';
import { initializeTranslations } from 'utils/initializeTranslations';
import { loadMessages as devExLoadMessages, locale as devExSetLocale } from 'devextreme/localization';
import frMessages from 'devextreme/localization/messages/fr.json';
import Routes from './Routes';
import { useStyles } from './appStyle';

const GLOBAL_SCOPE_TRANSLATIONS = [
  sharedTranslations.dates,
  prefixedTranslations(sharedTranslations.country_codes, 'COUNTRY_CODE|'),
] as const;

function ShowRoute() {
  const classes = useStyles();
  const { i18n } = useTranslation();

  const { setCurrentTheme, currentTheme } = useContext(CentralProviderContext);
  useEffect(() => setCurrentTheme('michelinLightBC'), [setCurrentTheme, currentTheme]);
  devExLoadMessages(frMessages);
  moment.locale(i18n.language.split('_')[0]);
  devExSetLocale(i18n.language.split('_')[0]);
  return (
    <div className={classes.root}>
      <div className={classes.appFrame}>
        <Routes />
      </div>
    </div>
  );
}
function App() {
  initializeTranslations(i18n, initReactI18next, GLOBAL_SCOPE_TRANSLATIONS).catch(() => {
    console.error('Failed to initialize translations!');
  });
  moment.locale('en-us');
  const printContext = usePrintContext();

  return (
    <MaestroQueryClientProvider
      defaultOptions={{
        queries: {
          refetchOnWindowFocus: false,
        },
      }}
      baseURL={apigatewayBaseRoute}
    >
      <CssBaseline />
      <CentralProvider
        redirect="/"
        application={APPS.FLEET_PORTAL}
        languages={[Languages.EN_US, Languages.FR_CA]}
        redirectToPreviousRoute
        onLogin={(previous: string) => {history.push(previous)}}
        themes={{on: THEMES.michelinLightBC,}}
        useCentralProviderDebugger={false}
        useTranslationDebugger={false}
        allowGrantLocationSelector={false}
        disableTranslationsManager
        devexLightThemeCSS={`${process.env.PUBLIC_URL}/css/dx.material.brand-center.css`}
        devexDarkThemeCSS={`${process.env.PUBLIC_URL}/css/dx.material.brand-center.css`}
      >
        <DialogProvider>
          <PrintContext.Provider value={printContext}>
            <Router history={history}>
              <PrintOrderPartList />
              <ShowRoute />
            </Router>
          </PrintContext.Provider>
        </DialogProvider>
      </CentralProvider>
    </MaestroQueryClientProvider>
  );
}

export default App;
